import { module } from "angular";
import core from "@gtmhub/core/module";
import { TagSelectorComponent } from "@webapp/tags/components/tag-selector/tag-selector.component";
import { TagService } from "./tag.service";

const mod = module("tags-core", [core]);

mod.service("TagService", TagService);
mod.downgradeComponent("tagSelector", { component: TagSelectorComponent, propagateDigest: false });

export default mod.name;
